import axios from "axios";
import { Base_URL } from "../url";

/**
 * =========================
 * HOLIDAY MASTER ORG APIs
 * =========================
 */

/**
 * Create Holiday
 */
export const createHoliday = async (payload, userName) => {
  try {
    const response = await axios.post(
      `${Base_URL}/HolidayMasterOrg/CreateHoliday`,
      payload,
      {
        params: { UserName: userName },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error creating holiday:", error);
    throw error;
  }
};

/**
 * Get Holidays by OrgId (Active only)
 */
export const getHolidaysByOrgId = async (orgId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/HolidayMasterOrg/GetHolidaysByOrg/${orgId}`,
    );
    return response.data;
  } catch (error) {
    console.error(`Error fetching holidays for OrgId ${orgId}:`, error);
    throw error;
  }
};

/**
 * Get All Holidays including inactive (for admin)
 */
export const getAllHolidaysByOrgId = async (orgId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/HolidayMasterOrg/GetAllHolidaysByOrg/${orgId}`,
    );
    return response.data;
  } catch (error) {
    console.error(`Error fetching all holidays for OrgId ${orgId}:`, error);
    throw error;
  }
};

/**
 * Get Deleted Holidays only
 */
export const getDeletedHolidaysByOrgId = async (orgId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/HolidayMasterOrg/GetDeletedHolidaysByOrg/${orgId}`,
    );
    return response.data;
  } catch (error) {
    console.error(`Error fetching deleted holidays for OrgId ${orgId}:`, error);
    throw error;
  }
};

/**
 * Get Holiday by HolidayId
 */
export const getHolidayById = async (holidayId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/HolidayMasterOrg/GetHolidayById/${holidayId}`,
    );
    return response.data;
  } catch (error) {
    console.error(`Error fetching holiday ${holidayId}:`, error);
    throw error;
  }
};

/**
 * Update Holiday by HolidayId
 */
export const updateHoliday = async (payload, userName) => {
  try {
    const response = await axios.put(
      `${Base_URL}/HolidayMasterOrg/UpdateHoliday`,
      payload,
      {
        params: { UserName: userName },
      },
    );
    return response.data;
  } catch (error) {
    console.error(
      `Error updating holiday with ID ${payload?.holidayId}:`,
      error,
    );
    throw error;
  }
};

/**
 * Soft Delete Holiday
 */
export const softDeleteHoliday = async (holidayId, userName) => {
  try {
    const response = await axios.delete(
      `${Base_URL}/HolidayMasterOrg/SoftDeleteHoliday/${holidayId}`,
      {
        params: { UserName: userName },
      },
    );
    return response.data;
  } catch (error) {
    console.error(`Error soft deleting holiday ${holidayId}:`, error);
    throw error;
  }
};

/**
 * Restore Holiday
 */
export const restoreHoliday = async (holidayId, userName) => {
  try {
    const response = await axios.put(
      `${Base_URL}/HolidayMasterOrg/RestoreHoliday/${holidayId}`,
      null,
      {
        params: { UserName: userName },
      },
    );
    return response.data;
  } catch (error) {
    console.error(`Error restoring holiday ${holidayId}:`, error);
    throw error;
  }
};

/**
 * Hard Delete Holiday (Permanent)
 */
export const hardDeleteHoliday = async (holidayId) => {
  try {
    const response = await axios.delete(
      `${Base_URL}/HolidayMasterOrg/HardDeleteHoliday/${holidayId}`,
    );
    return response.data;
  } catch (error) {
    console.error(`Error hard deleting holiday ${holidayId}:`, error);
    throw error;
  }
};
